import React, { lazy, Suspense } from "react";
import { observer } from "mobx-react";
import { Button, Menu, Row, Col, Card, Spin } from "antd";
import { ClickParam } from "antd/lib/menu";

declare var System: any;

import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';

interface Props extends ComponentViewProps<DataSet<IDocumentTemplateSummary>> {
	categories: DocumentTemplateCategorySummary[];
	categoryId?: number
	filterData: (categoryId: number) => void;
}

interface State {
	report?: IDocumentTemplateSummary;
}

@observer
export class DocumentTemplateListView extends React.Component<Props, State> {
	public state: State = {};

	private columns: Column[] = [
		{
			title: 'Name',
			key: 'displayName',
			dataIndex: 'displayName'
		},
		{
			title: 'Category',
			key: 'categoryDisplayName',
			dataIndex: 'categoryDisplayName'
		},
		{
			title: '',
			key: 'download',
			render: (value: any, report: IDocumentTemplateSummary) => {
				return (
					<Button
						icon="eye"
						onClick={this.showReportViewer(report)}
					/>
				);
			}
		}
	];

	public render(): React.ReactNode {
		const { model } = this.props;
		if (model == null || model.items == null) {
			return null;
		}
		const { report } = this.state;

		let body: React.ReactNode;
		if (report) {
			body = this.renderReport(report);
		} else {
			body = this.renderTable();
		}
		return (
			<div className="window window-normal">
				<div className="panel">
					{body}
				</div>
			</div>
		)
	}

	private renderReport(report: IDocumentTemplateSummary): React.ReactNode {
		const { setBusy } = this.props;

		const ReportComponent = lazy(() => System // using System because webpack & at-loader fails if using import alone
			.import(`./${report.reactComponent}`)
			.then(e => { // Process response because if component is not a default export, React fails.
				if (e.default) {
					return e;
				} else {
					const prop = Object.getOwnPropertyNames(e).filter(p => p != "__esModule" && typeof e[p] === "function");
					if (prop.length > 1) {
						throw new Error("More than one element should not be exported for reports!");
					}
					e.default = e[prop[0]];
					return e;
				}
			})
		);
		return (
			<Suspense fallback={<Spin spinning={true} />}>
				<ReportComponent model={report} setBusy={setBusy} close={this.showReportViewer()} />
			</Suspense>
		);
	}

	private renderTable(): React.ReactNode {
		const { categories, model, setBusy } = this.props;

		const panels = categories.map(x => (
			<Menu.Item key={x.id.toString()}>
				{x.displayName}
			</Menu.Item>
		));

		return (
			<Row gutter={16}>
				<Col xs={24} lg={8}>
					<Card title="Categories">
						<Menu
							onClick={this.handleClick}
							mode="vertical"
						>
							{panels}
						</Menu>
					</Card>
				</Col>
				<Col xs={24} lg={16}>
					<DataTableView
						setBusy={setBusy}
						columns={this.columns}
						model={model}
						hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons}
					/>
				</Col>
			</Row>
		);
	}

	private handleClick = (e: ClickParam) => {
		let id = parseInt(e.key);
		this.props.filterData(id);
	}

	private showReportViewer = (report?: IDocumentTemplateSummary) => () => {
		this.setState({ report });
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/report-list.view.tsx